//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CollapseTransition } from 'vue2-transitions';
import IconArr from '~/assets/img/icons/arr-accordion.svg?inline';

export default {
  name: 'UiInfoDocumentsGroup',
  components: {
    CollapseTransition,
    IconArr,
  },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      active: false,
    }
  },
  methods: {
    handleClick() {
      this.active = !this.active;
    },
  },
}
